import React from "react";
import { Loading } from "go-core/components/Loading";
import { ReactComponent as EmptyDataSVG } from "../../../../../images/svg/public/numberSystem/emptyData.svg";

interface Props {
	loading: boolean;
}

const NumberSystemEmptyData = ({ loading }: Props) => {
	return (
		<div className="bg-white w-100 h-100 d-flex align-items-center justify-content-center flex-column number-system-empty-data">
			<EmptyDataSVG />
			{loading && <Loading />}
		</div>
	);
};

export default NumberSystemEmptyData;
